import { defineStore } from "pinia";

export const useMenuStore = defineStore("menu", {
  state: () => ({
    backActive: false,
    menuVisible: true,
  }),

  actions: {
    setBackActive(value) {
      this.backActive = value;
    },
    setMenuVisible(value) {
      this.menuVisible = value;
    },
  },
});
